// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T21:08:16.551Z
// Property: Heather Lodge Apartments (ID: 6767906449166894)
// Collections: 15 amenities, 20 floorplans (live), 19 photos, 44 POIs, 2 reviews, 5 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166894",
  "property_external_id": "1461451",
  "property_zillow_url": "https://www.zillow.com/apartments/happy-valley-or/heather-lodge-apartments/BstWrT/",
  "property_apartments_url": "https://www.apartments.com/heather-lodge-apartments-happy-valley-or/rbxh1m2/",
  "property_google_business_url": "https://www.google.com/maps/place/Heather+Lodge+Apartments/data=!4m2!3m1!1s0x0:0xc62bc070114b95c5?sa=X&ved=2ahUKEwiFr6zdjLySAxV1jokEHbbxJfkQ_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "58428986965",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1461451 p1431078",
  "property_status": null,
  "property_slug": "heather-lodge-apartments",
  "property_name": "Heather Lodge Apartments",
  "property_website_url": "www.heatherlodgeapts.com",
  "property_domain": "https://www.heatherlodgeapts.com/",
  "property_address": "13432 SE 169th Ave",
  "property_full_address": "13432 SE 169th Ave, Happy Valley, OR, 97015",
  "property_address_1": "13432 SE 169th Ave",
  "property_address_2": null,
  "property_address_city": "Happy Valley",
  "property_address_state": "OR",
  "property_address_zip_full": null,
  "property_address_zip": "97015",
  "property_address_country": "US",
  "property_address_county": "Clackamas County",
  "property_neighborhood_address": "Rock Creek",
  "property_address_latitude": "45.4253",
  "property_address_longitude": "-122.4885",
  "property_email": "heatherlodge@ctlmanagement.com",
  "property_phone": "(503) 852-9409",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Heather Lodge in Happy Valley, OR, your ideal living space awaits! Choose from stylish studio to spacious three-bedroom floor plans. Enjoy top-tier amenities like a fully equipped fitness center, a seasonal swimming pool, and a welcoming clubhouse. Your vibrant lifestyle begins here—check availability or schedule a tour today!",
  "property_long_description": "**Welcome to Heather Lodge** – Your Sanctuary in Happy Valley, OR\n\nDiscover your new home at Heather Lodge, where comfort meets convenience in a vibrant community setting. Our thoughtfully designed apartments offer an array of floor plans to suit your unique lifestyle, including spacious studios, inviting one-bedroom, family-friendly two-bedroom, and expansive three-bedroom layouts. Whether you're looking for a cozy retreat or a place to accommodate your growing family, we have the perfect option for you.\n\nAt Heather Lodge, lifestyle amenities are just as important as your living space. Stay active and engaged with our fully equipped fitness center, perfect for morning workouts or evening strength training sessions. When the sun shines, take a refreshing dip in our seasonal swimming pool or unwind in the spa – the ideal spots to relax and rejuvenate. Our resident clubhouse is designed for connection, featuring games for all ages and a cozy fireside lounge where you can gather with friends or unwind after a long day.\n\nLocated in the heart of Happy Valley, Heather Lodge places you close to local shopping, dining, and outdoor recreation, making it easy to enjoy everything this charming community has to offer.\n\nDon’t miss out! **Find your new home today** – browse our availability or schedule a tour to experience everything Heather Lodge has to offer. Your perfect apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019db184-e45f-76ca-92d5-63371a1bf99e.webp",
  "property_featured_image_media": {
    "alt_text": "Stylish living room with a leather sofa, coffee table, and open-concept kitchen.",
    "public_id": "019db184-e45f-76ca-92d5-63371a1bf99e",
    "storage_key": "property/6767906449166894/019db184-e45f-76ca-92d5-63371a1bf99e.webp",
    "width": 1920,
    "height": 896
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "178",
  "property_year_built": "2021",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.57303370786516",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit (Refundable) - $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Deposit and monthly pet rent are per pet.  Small caged animals are allowed without a deposit and pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $25 | Deposit $400",
  "property_online_leasing_url": "https://heatherlodgeapts.securecafe.com/onlineleasing/heather-lodge/floorplans.aspx",
  "property_resident_portal_url": "https://heatherlodgeapts.securecafenet.com/residentservices/heather-lodge/userlogin",
  "property_apply_now_url": "https://heatherlodgeapts.securecafe.com/onlineleasing/heather-lodge/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019db5b8-59db-7026-9570-368d3bd9d3ea.webp",
  "property_primary_logo_media": {
    "alt_text": "Heather Lodge Apartments logo",
    "public_id": "019db5b8-59db-7026-9570-368d3bd9d3ea",
    "storage_key": "property/6767906449166894/019db5b8-59db-7026-9570-368d3bd9d3ea.webp",
    "width": 722,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019db5ba-4c16-73bd-81c5-86b29746ffa2.webp",
  "property_secondary_logo_media": {
    "alt_text": "Heather Lodge Apartments logo",
    "public_id": "019db5ba-4c16-73bd-81c5-86b29746ffa2",
    "storage_key": "property/6767906449166894/019db5ba-4c16-73bd-81c5-86b29746ffa2.webp",
    "width": 721,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019db5b8-d312-75cd-8235-739df98f441c.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Heather Lodge Apartments logo",
    "public_id": "019db5b8-d312-75cd-8235-739df98f441c",
    "storage_key": "property/6767906449166894/019db5b8-d312-75cd-8235-739df98f441c.webp",
    "width": 722,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019db5b8-c6ff-7136-8655-ad6cd8e5ae5c.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Heather Lodge Apartments logo",
    "public_id": "019db5b8-c6ff-7136-8655-ad6cd8e5ae5c",
    "storage_key": "property/6767906449166894/019db5b8-c6ff-7136-8655-ad6cd8e5ae5c.webp",
    "width": 722,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "691 - 1232",
  "property_sqft_min": "691",
  "property_sqft_max": "1232",
  "property_price_range": "1795 - 3050",
  "property_price_min": "1795",
  "property_price_max": "3050",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/HeatherLodgeApartments/",
  "property_instagram_url": "https://www.instagram.com/heatherlodgeapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJc-G-R1qflVQRxZVLEXDAK8Y",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/heather-lodge-apartments-happy-valley-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Heather Lodge",
  "property_home_romance_title": "Embrace Life in Your Charming New Apartment Community",
  "property_home_amenities_blurb": "At Heather Lodge in Happy Valley, OR, your lifestyle awaits! Dive into our seasonal swimming pool, unwind in the spa, or challenge friends in the resident clubhouse's game area. Our fully equipped fitness center makes staying active effortless—all within a welcoming community designed for modern living. Check us out today!",
  "property_home_floorplans_blurb": "Welcome to Heather Lodge in Happy Valley, OR, where comfort meets design. Our thoughtfully crafted floor plans cater to your lifestyle, whether you seek cozy nooks or spacious retreats. Browse our available apartment homes and let your ideal living space come to life in this vibrant community.",
  "property_home_gallery_blurb": "At Heather Lodge in Happy Valley, OR, your dream lifestyle awaits. Enjoy a fully equipped fitness center, take a refreshing dip in the seasonal swimming pool, or unwind in the cozy fireside lounge of our resident clubhouse. Picture yourself thriving in this vibrant community today!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Happy Valley, Heather Lodge offers a vibrant lifestyle with easy access to natural parks, local libraries, and engaging recreational spots. Enjoy close proximity to Powell Butte Nature Park, Happy Valley Park, and the captivating historical charm of downtown Gresham. Experience community living enriched by nature and culture!",
  "property_home_reviews_blurb": "At Heather Lodge in Happy Valley, OR, residents rave about the community's welcoming atmosphere, describing it as \"a hidden gem with exceptional amenities.\" Experience the unparalleled comfort and vibrant lifestyle our residents cherish. Curious about their stories? Dive into our reviews and see what life at Heather Lodge is all about!",
  "property_neighborhood_blurb": "At Heather Lodge in Happy Valley, vibrant living meets convenience. Enjoy tranquil moments at Powell Butte Nature Park or active days at North Clackamas Aquatic Park. Grab a book at the Multnomah County Library or immerse yourself in local culture at Historical Downtown Gresham. Your perfect home awaits, surrounded by endless exploration.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Heather Lodge in Happy Valley, OR, comfort meets style with versatile floor plans, including studios and three-bedroom apartments. Enjoy our fully equipped fitness center, relax by the seasonal swimming pool and spa, or unwind in the cozy resident clubhouse. Your ideal community awaits—experience it today!",
  "property_applynow_blurb": "At Heather Lodge in Happy Valley, OR, find the perfect space to call home, from cozy studios to spacious three-bedroom apartments. Enjoy a fully equipped fitness center, unwind by the seasonal pool and spa, and connect with neighbors in our inviting clubhouse. Lease online today and embrace your new lifestyle!",
  "property_contactus_blurb": "At Heather Lodge in Happy Valley, OR, you'll find the perfect floor plan tailored to your lifestyle, from cozy studios to spacious three-bedroom apartments. Whether you're seeking a modern retreat or room for family, we have options for everyone. Have questions? Contact our leasing team today for personalized assistance!",
  "property_faqs_blurb": "At Heather Lodge in Happy Valley, OR, we cater to every lifestyle with our diverse floor plans, from cozy studios to spacious three-bedroom apartments. Curious about living here? Answers await on our FAQs page—uncover the insights you need to make Heather Lodge your next home sweet home!",
  "property_floorplans_blurb": "At Heather Lodge in Happy Valley, OR, find the ideal living space tailored to your needs. Choose from stylish studio designs to spacious three-bedroom layouts. Each floor plan is crafted for comfort and convenience. Browse our available apartment homes today and envision your new lifestyle in a vibrant community.",
  "property_gallery_blurb": "At Heather Lodge in Happy Valley, OR, our photo gallery captures the essence of vibrant living. From spacious studios to cozy three-bedroom homes, each floor plan reflects comfort. Enjoy a fully equipped fitness center, seasonal swimming pool, or unwind in our inviting clubhouse. Picture yourself living here!",
  "property_interactivemap_blurb": "Nestled in the heart of Happy Valley, Heather Lodge offers a variety of thoughtfully designed floor plans, from cozy studios to spacious three-bedroom apartments. Enjoy a fully equipped fitness center, a seasonal swimming pool, and a welcoming clubhouse with games and a fireside lounge. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Heather Lodge in Happy Valley, pet lovers rejoice! Our community welcomes your cherished indoor cats and dogs—each weighing up to 25 lbs. Enjoy the company of small caged animals without extra fees, making your home a vibrant retreat for all your furry and scaly friends.",
  "property_referafriend_blurb": "At Heather Lodge in Happy Valley, OR, we believe great friends make great neighbors! With a variety of floor plans including cozy studios to spacious three-bedroom apartments, there's a perfect home for everyone. Invite a friend to join you in vibrant community living—refer them today and enjoy life together!",
  "property_residentaccess_blurb": "Welcome to Heather Lodge in Happy Valley, OR, where comfort meets convenience. Our diverse floor plans—ranging from cozy studios to spacious three-bedroom apartments—cater to every lifestyle. Access your resident portal to effortlessly pay rent, schedule maintenance, and enjoy a seamless living experience. Dive into your community today!",
  "property_reviews_blurb": "At Heather Lodge in Happy Valley, OR, residents rave about the \"welcoming atmosphere and exceptional management.\" Don't just take our word for it—dive into our reviews to see why our community feels like home. Join us and experience the warmth that makes living here truly special!",
  "property_created_at": "1762784892703",
  "property_scheduletour_blurb": "At Heather Lodge in Happy Valley, OR, choose from thoughtfully designed studio, one, two, and three-bedroom floor plans that reflect your unique lifestyle. Enjoy modern amenities, serene surroundings, and a vibrant community atmosphere. Curious about life here? Schedule a tour and hear firsthand from our satisfied residents!",
  "property_thankyou_blurb": "Thank you for your interest in Heather Lodge, where your ideal home in Happy Valley awaits! Whether you’re dreaming of a cozy studio or a spacious three-bedroom apartment, we have the perfect layout to suit your lifestyle. Expect a prompt reply from our team to assist you further!",
  "property_virtualtours_blurb": "Step into Heather Lodge in Happy Valley, OR, where comfort meets style in our thoughtfully designed studio, one, two, and three-bedroom apartments. Experience the charm of our vibrant community—take a virtual tour today and imagine your future at Heather Lodge!",
  "property_copyright": "2025 All Rights Reserved. Heather Lodge",
  "property_seo_title_home": "Heather Lodge |  Apartments in Happy Valley, OR",
  "property_seo_description_home": "Discover Heather Lodge in Happy Valley, OR! Choose from stylish studios to spacious 3-bedrooms with exceptional amenities. Find your new home!",
  "property_seo_title_floorplans": "Floor Plans | Happy Valley, OR Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Heather Lodge in Happy Valley, OR! From cozy studios to spacious three-bedrooms, explore diverse floor plans tailored for you.",
  "property_seo_title_amenities": "Amenities | Happy Valley, OR Apartments for Rent",
  "property_seo_description_amenities": "Relax at Heather Lodge in Happy Valley, OR! Enjoy a clubhouse, fitness center, and seasonal pool—your perfect retreat awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Happy Valley, OR",
  "property_seo_description_gallery": "Experience life at Heather Lodge in Happy Valley, OR! Choose from cozy studios to spacious three-bedrooms with great amenities like a pool and gym.",
  "property_seo_title_virtualtours": "Virtual Tours | Heather Lodge Apartments",
  "property_seo_description_virtualtours": "Discover Heather Lodge in Happy Valley, OR! Take a virtual tour of our beautiful studio to three-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Heather Lodge Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Heather Lodge in Happy Valley, OR! Explore our interactive map for studios to 3-bedroom apartments and great amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Happy Valley, OR",
  "property_seo_description_neighborhood": "Uncover the charm of Heather Lodge in Happy Valley, OR. Enjoy vibrant local favorites and explore nearby attractions that make living here a delight!",
  "property_seo_title_contact": "Contact Us | Heather Lodge",
  "property_seo_description_contact": "Find your perfect space at Heather Lodge in Happy Valley, OR. From cozy studios to spacious three-bedroom apartments, our leasing team is ready to assist!",
  "property_seo_title_faqs": "FAQs | Apartments in Happy Valley, OR",
  "property_seo_description_faqs": "Uncover answers to your questions about Heather Lodge in Happy Valley, OR! From cozy studios to vibrant amenities, find everything you need in our FAQs.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Happy Valley, OR",
  "property_seo_description_reviews": "Experience life at Heather Lodge in Happy Valley, OR! Check out resident reviews and see why our community, with top-notch amenities, feels like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Happy Valley, OR",
  "property_seo_description_applynow": "Find your ideal space at Heather Lodge in Happy Valley, OR. Enjoy modern living with top amenities, from a fitness center to a seasonal pool. Apply online now!",
  "property_seo_title_residentaccess": "Resident Access | Heather Lodge",
  "property_seo_description_residentaccess": "Log in to Heather Lodge's portal to pay rent, schedule maintenance, and manage your apartment in Happy Valley, OR. Enjoy hassle-free living!",
  "property_seo_title_referafriend": "Refer A Friend | Heather Lodge",
  "property_seo_description_referafriend": "Refer a friend to Heather Lodge in Happy Valley, OR! Great friends make the best neighbors—share the joy of living in a vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Heather Lodge",
  "property_seo_description_scheduletour": "Experience the charm of Heather Lodge in Happy Valley, OR. Schedule your tour today and find your perfect home amidst lush landscapes and inviting spaces!",
  "property_seo_title_privacy": "Privacy Policy | Heather Lodge",
  "property_seo_description_privacy": "At Heather Lodge in Happy Valley, OR, your privacy matters. Read our comprehensive privacy policy to see how we protect your data while you enjoy your home.",
  "property_seo_title_accessibility": "Website Accessibility | Heather Lodge",
  "property_seo_description_accessibility": "At Heather Lodge in Happy Valley, we embrace digital inclusion. Our accessibility statement reflects our commitment to all residents. Join our community today!",
  "property_seo_title_sitemap": "Sitemap | Heather Lodge",
  "property_seo_description_sitemap": "Navigate Heather Lodge’s sitemap for a seamless journey through our Happy Valley community. Your perfect home awaits—find it with ease today!",
  "property_seo_title_thankyou": "Thank You | Heather Lodge",
  "property_seo_description_thankyou": "Thank you for reaching out to Heather Lodge in Happy Valley! A team member will connect soon to help you find your perfect home. Exciting times ahead!",
  "property_seo_title_pets": "Pet Policy | Apartments in Happy Valley, OR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1789628740364",
  "amenities": [
    {
      "id": "ec_40c7b36e7e3acba80d78295e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "89650431",
      "title": "Soak or swim—pool and hot tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d9a48-38e5-77ee-8903-5858e58a046d.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "019d9a48-38e5-77ee-8903-5858e58a046d",
        "storage_key": "property/6767906449166894/019d9a48-38e5-77ee-8903-5858e58a046d.webp",
        "width": 3056,
        "height": 2038
      },
      "amenity_image_alt_text": "Heather Lodge Pool Lounge Chairs,Heather Lodge Swimming Pool",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0101086e333880021aec61ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "89650429",
      "title": "Game on! Clubhouse with fireside lounge and board games",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b6b0af09805ba1e34483559",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "89650430",
      "title": "Workout for the weekend—fully equipped fitness center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1c07-7b75-70ad-b3fd-95f45bb3eb76.webp",
      "amenity_image_media": {
        "alt_text": "Gym with treadmills, ellipticals, spin bike, and stability balls.",
        "public_id": "019d1c07-7b75-70ad-b3fd-95f45bb3eb76",
        "storage_key": "property/6767906449166894/019d1c07-7b75-70ad-b3fd-95f45bb3eb76.webp",
        "width": 1024,
        "height": 768
      },
      "amenity_image_alt_text": "Heather Lodge Fitness Center",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d2d119ca041c92f4c74785f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "89650433",
      "title": "Co-captain's quarters—off leash dog park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28bfa2b0a53cf4ce3d3dd343",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "89650434",
      "title": "Add to Cart! Parcel delivery lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e62b171e1c77d28745439abd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "89650436",
      "title": "Got gear? Indoor bike storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99b18f371bfd588338165726",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "125262782",
      "title": "Hit the road—parking available for rent",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86efe3b7c8c9e10ff2a4651b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "89650435",
      "title": "Get going—electric vehicle charging",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9328e8f1286ca3d0fd56ee67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "89650437",
      "title": "Fuel up—modern kitchens with full-size stainless-steel appliances, quartz countertops and soft close cabinets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1c07-7b72-73ed-a02e-92405f892e51.webp",
      "amenity_image_media": {
        "alt_text": "Modern apartment kitchen with dark grey cabinets, stainless steel appliances, and white subway tile backsplash.",
        "public_id": "019d1c07-7b72-73ed-a02e-92405f892e51",
        "storage_key": "property/6767906449166894/019d1c07-7b72-73ed-a02e-92405f892e51.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Heather Lodge 2x2 Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ece5852a9674a7ca893c366f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "89650442",
      "title": "Stash your gear—spacious walk-in closets in select homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1f0b-8c08-724a-bd5b-fe47e6fc7777.webp",
      "amenity_image_media": {
        "alt_text": "Spacious walk-in closet with wall-mounted shelving and a wooden coat rack.",
        "public_id": "019d1f0b-8c08-724a-bd5b-fe47e6fc7777",
        "storage_key": "property/6767906449166894/019d1f0b-8c08-724a-bd5b-fe47e6fc7777.webp",
        "width": 3017,
        "height": 2011
      },
      "amenity_image_alt_text": "Heather Lodge 2x2 Large Bedroom Walk In Closet",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8d301c9a1aabec5184e1764",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "89650440",
      "title": "Warm up or cool down—personalized heating and air conditioning system",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1c07-7b76-732c-bf05-a209e410560f.webp",
      "amenity_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and balcony view",
        "public_id": "019d1c07-7b76-732c-bf05-a209e410560f",
        "storage_key": "property/6767906449166894/019d1c07-7b76-732c-bf05-a209e410560f.webp",
        "width": 2971,
        "height": 1981
      },
      "amenity_image_alt_text": "Heather Lodge 2x2 Living Room and Air Conditioner",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48fd61dc7b8bc9e39a4eae97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "89650438",
      "title": "Come and go with ease—electronic door locks",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1324afc2cb74129ce4a44cf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "89650443",
      "title": "Recharge—your own private deck in select homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d20b8-7793-74ec-9c03-623fa61279b6.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with seating overlooking a tree-lined street and houses.",
        "public_id": "019d20b8-7793-74ec-9c03-623fa61279b6",
        "storage_key": "property/6767906449166894/019d20b8-7793-74ec-9c03-623fa61279b6.webp",
        "width": 3010,
        "height": 2007
      },
      "amenity_image_alt_text": "Heather Lodge Deck Area",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a211e171bedaec3f884a4fb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "89650439",
      "title": "Just right lighting—dimmer switches for enhanced ambience",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b515e19f7ea06143d5d50216",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "yardi",
      "external_id": "89650444",
      "title": "Enjoy the scenery—picturesque woodland views in select homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_6a61dc3188c45b7305880050",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1f0b-a1e8-721d-b3bc-ccda903ff660.webp",
      "image_media": {
        "alt_text": "Heather Lodge Apartments monument sign with building in background",
        "public_id": "019d1f0b-a1e8-721d-b3bc-ccda903ff660",
        "storage_key": "property/6767906449166894/019d1f0b-a1e8-721d-b3bc-ccda903ff660.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Welcome sign for Heather Lodge Apartments, featuring the property's name and logo, with the apartment building visible behind it.",
      "link": "false",
      "alt_text": "Heather Lodge Apartments monument sign with building in background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/IMG_6017-edit~b-hi-res.jpg"
    },
    {
      "id": "ec_6c00058c207cf3caf55e27a7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1c07-7c38-774f-a439-7f30e44b46c2.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with wood and metal accents, large windows, and landscaping.",
        "public_id": "019d1c07-7c38-774f-a439-7f30e44b46c2",
        "storage_key": "property/6767906449166894/019d1c07-7c38-774f-a439-7f30e44b46c2.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "The exterior of the apartment complex features a contemporary design with a mix of wood and metal siding, large windows, and well-maintained landscaping.",
      "link": "false",
      "alt_text": "Modern apartment building exterior with wood and metal accents, large windows, and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_12_HeatherLodgeLeasingOfficehighres_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_2c2aa525b02f62582d4a2f18",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1bfc-ee89-7237-ba99-c7bc85effa12.webp",
      "image_media": {
        "alt_text": "Exterior of the Heather apartment building with a 'Now Leasing' banner.",
        "public_id": "019d1bfc-ee89-7237-ba99-c7bc85effa12",
        "storage_key": "property/6767906449166894/019d1bfc-ee89-7237-ba99-c7bc85effa12.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Modern apartment building exterior, featuring a prominent 'Now Leasing' banner. Offers a glimpse of the community's architecture and available units.",
      "link": "false",
      "alt_text": "Exterior of the Heather apartment building with a 'Now Leasing' banner.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_11_HeatherLodgeExteriorBuildinghighres_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_29dbf75e3bf0f5d4f17021eb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1bfc-eec3-75be-a118-0b8bd34c1b44.webp",
      "image_media": {
        "alt_text": "Community lounge area with dining table, pool table, and bar.",
        "public_id": "019d1bfc-eec3-75be-a118-0b8bd34c1b44",
        "storage_key": "property/6767906449166894/019d1bfc-eec3-75be-a118-0b8bd34c1b44.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Enjoy the community lounge, complete with a dining table, pool table, and bar area for residents.",
      "link": "false",
      "alt_text": "Community lounge area with dining table, pool table, and bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_8_Clubhouse1highres_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_75a9fe9c73209328e1a1afb8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1f0b-8e61-726f-ac39-f33bd966bb62.webp",
      "image_media": {
        "alt_text": "Community lounge area with a billiards table and bar seating.",
        "public_id": "019d1f0b-8e61-726f-ac39-f33bd966bb62",
        "storage_key": "property/6767906449166894/019d1f0b-8e61-726f-ac39-f33bd966bb62.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and entertain in our stylish community lounge, featuring a billiards table, ample seating, and a modern bar area perfect for socializing.",
      "link": "false",
      "alt_text": "Community lounge area with a billiards table and bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/img_5804-edit_b-lo-res.jpg"
    },
    {
      "id": "ec_90305149ba16bf7cf6186ac9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1f0b-8d34-71bf-8a18-838922147f70.webp",
      "image_media": {
        "alt_text": "Living room with leather sofa, unique coffee tables, and colorful chairs.",
        "public_id": "019d1f0b-8d34-71bf-8a18-838922147f70",
        "storage_key": "property/6767906449166894/019d1f0b-8d34-71bf-8a18-838922147f70.webp",
        "width": 1800,
        "height": 2200
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a plush leather sofa, abstract coffee tables, and vibrant accent chairs, perfect for relaxation and socializing.",
      "link": "false",
      "alt_text": "Living room with leather sofa, unique coffee tables, and colorful chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/img_5847-overlay-edit_b-lo-res(1).jpg"
    },
    {
      "id": "ec_d7a7bd87158a09367613c134",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1c07-7b75-70ad-b3fd-95f45bb3eb76.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, spin bike, and stability balls.",
        "public_id": "019d1c07-7b75-70ad-b3fd-95f45bb3eb76",
        "storage_key": "property/6767906449166894/019d1c07-7b75-70ad-b3fd-95f45bb3eb76.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, free weights, and yoga balls for a complete workout experience.",
      "link": "false",
      "alt_text": "Gym with treadmills, ellipticals, spin bike, and stability balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_10_Fitness1highres_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_59bf005df4fd3ecc93843593",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1c07-7b75-70ad-b3fd-90533046daea.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "019d1c07-7b75-70ad-b3fd-90533046daea",
        "storage_key": "property/6767906449166894/019d1c07-7b75-70ad-b3fd-90533046daea.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, complete with comfortable lounge chairs and umbrellas for shade.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and umbrellas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_17_poolview2highres_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_ad818e1a2f8c611a4c447acf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1bfc-ee78-728f-8286-b99332fb8df0.webp",
      "image_media": {
        "alt_text": "Row of lounge chairs with yellow pillows next to an outdoor swimming pool.",
        "public_id": "019d1bfc-ee78-728f-8286-b99332fb8df0",
        "storage_key": "property/6767906449166894/019d1bfc-ee78-728f-8286-b99332fb8df0.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and refreshing umbrellas. Perfect for soaking up the sun or enjoying a cool dip.",
      "link": "false",
      "alt_text": "Row of lounge chairs with yellow pillows next to an outdoor swimming pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_16_poolview1highres_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_848a8774b7bc233a5b760aa9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1c07-7b72-73ed-a02e-92405f892e51.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with dark grey cabinets, stainless steel appliances, and white subway tile backsplash.",
        "public_id": "019d1c07-7b72-73ed-a02e-92405f892e51",
        "storage_key": "property/6767906449166894/019d1c07-7b72-73ed-a02e-92405f892e51.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a fully-equipped kitchen featuring sleek dark grey cabinetry, a stainless steel refrigerator, stove, microwave, and dishwasher, perfect for culinary creations.",
      "link": "false",
      "alt_text": "Modern apartment kitchen with dark grey cabinets, stainless steel appliances, and white subway tile backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_13_KitchenPhoto2bdrmfloorplanhighres1_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_0a27d8cef46b541bc536d4bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1c07-7c9d-76e0-85c6-ff9b27053353.webp",
      "image_media": {
        "alt_text": "Living room with leather sofa, coffee table, and open kitchen view.",
        "public_id": "019d1c07-7c9d-76e0-85c6-ff9b27053353",
        "storage_key": "property/6767906449166894/019d1c07-7c9d-76e0-85c6-ff9b27053353.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable leather sofa, modern coffee table, and an adjacent open-concept kitchen with sleek cabinetry and stainless steel appliances.",
      "link": "false",
      "alt_text": "Living room with leather sofa, coffee table, and open kitchen view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_14_Livingroomandkitchenphoto1bdrmfloorplanHighRes_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_19770a33736119553a1f13f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1c07-7b76-732c-bf05-a209e410560f.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and balcony view",
        "public_id": "019d1c07-7b76-732c-bf05-a209e410560f",
        "storage_key": "property/6767906449166894/019d1c07-7b76-732c-bf05-a209e410560f.webp",
        "width": 2971,
        "height": 1981
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable sectional sofa, stylish coffee table, and a beautiful view from the balcony. Perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with sectional sofa, coffee table, and balcony view",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_15_LivingRoomphoto2bdrmfloorplanHighRes_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_cdbc79bc2e50b2ce58b7e937",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1c07-7c9a-7241-af2b-935b84ff65e2.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, bedside tables, and mountain landscape art.",
        "public_id": "019d1c07-7c9a-7241-af2b-935b84ff65e2",
        "storage_key": "property/6767906449166894/019d1c07-7c9a-7241-af2b-935b84ff65e2.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Relax in this inviting bedroom featuring a comfortable bed, modern bedside lamps, and a scenic mountain view art piece.",
      "link": "false",
      "alt_text": "Cozy bedroom with a queen-size bed, bedside tables, and mountain landscape art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_6_bedroom2highres2_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_51377d10df4f03ad30fc8c1f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1f0b-8c08-724a-bd5b-fe47e6fc7777.webp",
      "image_media": {
        "alt_text": "Spacious walk-in closet with wall-mounted shelving and a wooden coat rack.",
        "public_id": "019d1f0b-8c08-724a-bd5b-fe47e6fc7777",
        "storage_key": "property/6767906449166894/019d1f0b-8c08-724a-bd5b-fe47e6fc7777.webp",
        "width": 3017,
        "height": 2011
      },
      "title": "Apartment",
      "description": "Maximize your storage with this expansive walk-in closet, featuring ample shelving and a decorative coat rack for your convenience.",
      "link": "false",
      "alt_text": "Spacious walk-in closet with wall-mounted shelving and a wooden coat rack.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_7_ClosetSpacefor2bdrmhighres1_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_0633dfb1f5db506d7a763d15",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1eda-6428-777d-8352-d657b34ecf6d.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, plush pillows, and a decorative throw blanket.",
        "public_id": "019d1eda-6428-777d-8352-d657b34ecf6d",
        "storage_key": "property/6767906449166894/019d1eda-6428-777d-8352-d657b34ecf6d.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Charming bedroom featuring a queen-size bed with a dark upholstered headboard, crisp white linens, and a cozy knit throw. Two abstract art pieces adorn the wall above the bed, and a modern bedside table holds a stylish lamp and decorative candle.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, plush pillows, and a decorative throw blanket.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_5_Bedroom1HighRes_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_8c400b49fbfd983709b91294",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1eda-6422-723e-ae9e-f44bd4c8e3c0.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, blue headboard, bedside tables, and a large window.",
        "public_id": "019d1eda-6422-723e-ae9e-f44bd4c8e3c0",
        "storage_key": "property/6767906449166894/019d1eda-6422-723e-ae9e-f44bd4c8e3c0.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "A well-lit and comfortable bedroom featuring a queen-size bed with plush bedding, elegantly designed bedside tables, and a large window offering scenic views. Perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, blue headboard, bedside tables, and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_4_beddroom2highres_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_3b745b6e35f1df9e44e9edd9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1eda-6425-719b-a86f-fd72dc79d339.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower.",
        "public_id": "019d1eda-6425-719b-a86f-fd72dc79d339",
        "storage_key": "property/6767906449166894/019d1eda-6425-719b-a86f-fd72dc79d339.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Explore this contemporary bathroom featuring a spacious vanity, a comfortable toilet, and a sleek shower with a decorative curtain. A perfect blend of style and functionality.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, toilet, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_3_Bathroompicfor2bdrmmasterhighres_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_53d18cb49a5d8bb7bb7664d6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1eda-63c2-72e4-b6a1-4604cba2a4a0.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and shower/tub.",
        "public_id": "019d1eda-63c2-72e4-b6a1-4604cba2a4a0",
        "storage_key": "property/6767906449166894/019d1eda-63c2-72e4-b6a1-4604cba2a4a0.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a spacious vanity, a toilet, and a shower/tub combo with a stylish shower curtain.",
      "link": "false",
      "alt_text": "Modern bathroom with a vanity, toilet, and shower/tub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_2_Bathroompicfor2bdrmhighres_1_PhotoGallery_Optimized.jpg"
    },
    {
      "id": "ec_003e5465fee61bf81bbdee55",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d1eda-6487-726d-be26-53f0a930795b.webp",
      "image_media": {
        "alt_text": "Balcony with seating overlooking trees and adjacent units.",
        "public_id": "019d1eda-6487-726d-be26-53f0a930795b",
        "storage_key": "property/6767906449166894/019d1eda-6487-726d-be26-53f0a930795b.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Enjoy your private balcony with comfortable seating, offering scenic views of the surrounding trees and neighboring apartments.",
      "link": "false",
      "alt_text": "Balcony with seating overlooking trees and adjacent units.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/p1431078_1_BalconyPhoto2bdrmfloorplanHighRes_1_PhotoGallery_Optimized.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_650de412-93e4-4f89-87fb-ccd438038312",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "12520 SE 93rd Ave, Clackamas, OR 97015, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches and waffle fries. They also highlight the fast service, friendly staff, and accurate orders.\n\nSome reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-1ef7-74e3-a8e6-23f781271394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1ef7-74e3-a8e6-23f781271394",
        "storage_key": "property/6767906449166894/019d08ae-1ef7-74e3-a8e6-23f781271394.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/or/clackamas-promenade?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10516814392215825249&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "45.4328424",
      "poi_longitude": "-122.5691502",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-308-6953",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-c25f-71ad-8ec8-4e2f80a620b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-c25f-71ad-8ec8-4e2f80a620b5",
        "storage_key": "property/6767906449166894/019d08ad-c25f-71ad-8ec8-4e2f80a620b5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV5zTBIN1lVQRYWu9IPg685E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_2d089c43-d77d-4770-bda7-d7f255fc5b0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "12000 SE 82nd Ave Suite 2044, Happy Valley, OR 97086, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant serves delicious cheesecake, pasta, and meatloaf. They also highlight the fast service, friendly staff, and customizable menu.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-1e9d-71eb-b44d-57dd1ac86e7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1e9d-71eb-b44d-57dd1ac86e7e",
        "storage_key": "property/6767906449166894/019d08ae-1e9d-71eb-b44d-57dd1ac86e7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/or/happy-valley-204.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=7876637345155142451&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "45.4353546",
      "poi_longitude": "-122.5742665",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-653-1353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-c25f-71ad-8ec8-4e2f80a620b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-c25f-71ad-8ec8-4e2f80a620b5",
        "storage_key": "property/6767906449166894/019d08ad-c25f-71ad-8ec8-4e2f80a620b5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0uUvIJ1lVQRM1OM5u5vT20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4f0c5529-fd39-4791-9a09-78689b14ae38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Stone Cliff Inn",
      "poi_type": "Restaurants",
      "poi_address": "17900 S Clackamas River Dr, Oregon City, OR 97045, USA",
      "poi_short_description": "Log cabin-style restaurant offering a Pacific Northwest menu & deck seating with scenic river views.",
      "poi_long_description": "People say this Pacific Northwest restaurant offers delicious ribs, steelhead, and bread pudding. They highlight the beautiful river views, cozy atmosphere, and friendly staff. They also like the attentive service and the option to dine on the patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-1e93-760d-bcf2-023559633a1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1e93-760d-bcf2-023559633a1e",
        "storage_key": "property/6767906449166894/019d08ae-1e93-760d-bcf2-023559633a1e.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.stonecliffinn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2491704831467809939&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stone-cliff-inn",
      "poi_latitude": "45.3921055",
      "poi_longitude": "-122.4986943",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-631-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-c25f-71ad-8ec8-4e2f80a620b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-c25f-71ad-8ec8-4e2f80a620b5",
        "storage_key": "property/6767906449166894/019d08ad-c25f-71ad-8ec8-4e2f80a620b5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPUIjSYqdlVQRk2zDtFdQlCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8404b4fd-cd58-40c0-8b6b-aa34c6a9169c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Dave's Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "9757 SE Sunnyside Rd, Clackamas, OR 97015, USA",
      "poi_short_description": "Casual joint dishing up chicken tenders and sliders featuring a range of heat levels.",
      "poi_long_description": "People say this chicken restaurant serves delicious chicken sliders, tenders, and sandwiches with a variety of spice levels. They highlight the generous portions, fresh ingredients, and tasty fries, as well as the reasonable prices and fun, welcoming atmosphere. They also like the friendly, helpful, and efficient staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-1e86-7631-8d94-742deb411d2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1e86-7631-8d94-742deb411d2f",
        "storage_key": "property/6767906449166894/019d08ae-1e86-7631-8d94-742deb411d2f.webp",
        "width": 1280,
        "height": 650
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7927548305514048385&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daves-hot-chicken",
      "poi_latitude": "45.4335656",
      "poi_longitude": "-122.5632132",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-451-6999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-c25f-71ad-8ec8-4e2f80a620b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-c25f-71ad-8ec8-4e2f80a620b5",
        "storage_key": "property/6767906449166894/019d08ad-c25f-71ad-8ec8-4e2f80a620b5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQfwgPA11lVQRgSvqkS5PBG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5d87c281-63e0-48f1-b89b-173e17d510dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "K-Town Korean BBQ Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5450 SE 82nd Ave, Portland, OR 97266, USA",
      "poi_short_description": "Upbeat eatery specializing in Korean-style DIY BBQ, with all-you-can-eat options, plus beer & soju.",
      "poi_long_description": "People say this Korean barbecue restaurant offers a wide variety of flavorful marinated meats, including bulgogi, pork belly, and brisket, with all-you-can-eat options. They also highlight the fun, interactive experience of cooking your own food, the generous portions, and the delicious cocktails.\n\nSome reviews mention the staff can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-24e7-717d-8b13-e01d3d4ed06f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-24e7-717d-8b13-e01d3d4ed06f",
        "storage_key": "property/6767906449166894/019d08ae-24e7-717d-8b13-e01d3d4ed06f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ktownkoreanbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15576256481430841968&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "k-town-korean-bbq-restaurant",
      "poi_latitude": "45.4824177",
      "poi_longitude": "-122.5773664",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-444-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-c25f-71ad-8ec8-4e2f80a620b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-c25f-71ad-8ec8-4e2f80a620b5",
        "storage_key": "property/6767906449166894/019d08ad-c25f-71ad-8ec8-4e2f80a620b5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgXB6TCKglVQRcKoPSr76Kdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "custom_38f83e29-5e52-4edf-9276-cfe7eb8cfc41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Clackamas Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "12000 SE 82nd Ave, Happy Valley, OR 97086, USA",
      "poi_short_description": "Chain retailer offering trendy, brand-name clothing & shoes, plus gear for skate- & snowboarders.",
      "poi_long_description": "People say this shopping center has a wide variety of stores, a movie theater, and a food court with plenty of dining options. They also highlight the clean and friendly atmosphere, and ample parking.\n\nSome reviews mention the maintenance can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-b08b-71d8-aa97-21bc072fce51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-b08b-71d8-aa97-21bc072fce51",
        "storage_key": "property/6767906449166894/019d08ad-b08b-71d8-aa97-21bc072fce51.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.clackamastowncenter.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12922097351639682301&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clackamas-town-center",
      "poi_latitude": "45.4358909",
      "poi_longitude": "-122.5732894",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-653-6613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-c929-721c-9ef0-700ce23dceda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-c929-721c-9ef0-700ce23dceda",
        "storage_key": "property/6767906449166894/019d08ad-c929-721c-9ef0-700ce23dceda.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnyaLa3h1lVQR_cx_vRODVLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_90b1534e-a11f-4255-a072-7cec2c36e775",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "11250 SE 82nd Ave, Happy Valley, OR 97086, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "Shoppers say this supermarket offers great prices on a wide selection of products, including their own store brand, and has a great bulk section. They also highlight the friendly and helpful staff, and appreciate that it's open 24 hours.\n\nSome reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-5ec8-72ce-8a1b-830bbfe71cf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-5ec8-72ce-8a1b-830bbfe71cf0",
        "storage_key": "property/6767906449166894/019d08ad-5ec8-72ce-8a1b-830bbfe71cf0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17488109587138100289&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "45.443687",
      "poi_longitude": "-122.577712",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-654-3210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-c2b9-7108-94da-6e3d194c3bc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-c2b9-7108-94da-6e3d194c3bc4",
        "storage_key": "property/6767906449166894/019d08ad-c2b9-7108-94da-6e3d194c3bc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWZ6aTXt1lVQRQTx4dgM_svI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_dab9a320-333f-4c53-846b-1635dffc53d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9300 SE 82nd Ave, Happy Valley, OR 97086, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of supplies for home, yard, and DIY projects. They also highlight the helpful and friendly staff, and the convenient parking.\n\nOther reviews mention the self-checkout can be annoying.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-24fe-701f-99f2-365ca8868378.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-24fe-701f-99f2-365ca8868378",
        "storage_key": "property/6767906449166894/019d08ae-24fe-701f-99f2-365ca8868378.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.homedepot.com/l/Clackamas/OR/Happy-Valley/97086/4040?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3259447857262236735&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "45.4558601",
      "poi_longitude": "-122.5769063",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-774-6342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-c929-721c-9ef0-700ce23dceda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-c929-721c-9ef0-700ce23dceda",
        "storage_key": "property/6767906449166894/019d08ad-c929-721c-9ef0-700ce23dceda.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDWAVluCflVQRPxQGkI7iOy0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_63a33f8a-40a5-4981-9236-a4b4d72713b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "9345 SE 82nd Ave, Clackamas, OR 97086, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, meat, dairy, baked goods, and gluten-free options, as well as a large selection of beer, cider, and wine. They highlight the affordable prices, especially on eggs, and the good value for the quality of products, including frozen foods and organic options. They also like the friendly and helpful staff, and the efficient checkout process.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-26bd-729c-9632-88831e6d9b9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-26bd-729c-9632-88831e6d9b9b",
        "storage_key": "property/6767906449166894/019d08ae-26bd-729c-9632-88831e6d9b9b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/or/clackamas/152/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16829395124031297543&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "45.4558588",
      "poi_longitude": "-122.5807379",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-771-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-c2b9-7108-94da-6e3d194c3bc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-c2b9-7108-94da-6e3d194c3bc4",
        "storage_key": "property/6767906449166894/019d08ad-c2b9-7108-94da-6e3d194c3bc4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9Zo-OCflVQRB5iTCLMFjuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2f701511-6017-4c4a-af64-8e4e57ddb440",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2002 Washington St, Oregon City, OR 97045, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a vast selection of products and tools. They also highlight the helpful and friendly staff, and the convenient self-checkout system.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-278d-7158-93ac-72a2923efe04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-278d-7158-93ac-72a2923efe04",
        "storage_key": "property/6767906449166894/019d08ae-278d-7158-93ac-72a2923efe04.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Oregon-City/OR/Oregon-City/97045/4017?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11839607455757676165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "45.3690547",
      "poi_longitude": "-122.5868732",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-723-3181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-c929-721c-9ef0-700ce23dceda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-c929-721c-9ef0-700ce23dceda",
        "storage_key": "property/6767906449166894/019d08ad-c929-721c-9ef0-700ce23dceda.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa01TF792lVQRha6AiEC8TqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_fe1a7d67-2be5-44ab-832b-5959bc0cb4a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Multnomah County Library - Gresham",
      "poi_type": "Education",
      "poi_address": "385 NW Miller Ave, Gresham, OR 97030, USA",
      "poi_short_description": "Public library with helpful staff, books, movies, computers, and other resources.",
      "poi_long_description": "People say this public library offers a large children's area and a good selection of books. They highlight the friendly and helpful staff. They also like the nice vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-2bc0-76e9-a1be-b0d81368cb3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-2bc0-76e9-a1be-b0d81368cb3f",
        "storage_key": "property/6767906449166894/019d08ae-2bc0-76e9-a1be-b0d81368cb3f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://multcolib.org/library-location/gresham",
      "poi_directions_map_url": "https://maps.google.com/?cid=6661803061903270582&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "multnomah-county-library---gresham",
      "poi_latitude": "45.5002338",
      "poi_longitude": "-122.4329452",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-988-5123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-c9f7-7069-b7b8-f10c7d90d411.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-c9f7-7069-b7b8-f10c7d90d411",
        "storage_key": "property/6767906449166894/019d08ad-c9f7-7069-b7b8-f10c7d90d411.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzwMvUvOYlVQRtqJazJZ6c1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_3826407a-d4d0-46f9-a78f-5273f81ee1dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Happy Valley Library",
      "poi_type": "Education",
      "poi_address": "13793 SE Sieben Park Way, Happy Valley, OR 97015, USA",
      "poi_short_description": "Library featuring a large kids section, playgrounds, computers and friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-2bc5-7590-a6bb-aec535b5c77b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-2bc5-7590-a6bb-aec535b5c77b",
        "storage_key": "property/6767906449166894/019d08ae-2bc5-7590-a6bb-aec535b5c77b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.happyvalleyor.gov/library",
      "poi_directions_map_url": "https://maps.google.com/?cid=1475033132729827408&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "happy-valley-library",
      "poi_latitude": "45.42274829999999",
      "poi_longitude": "-122.5127657",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-783-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-c9f7-7069-b7b8-f10c7d90d411.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-c9f7-7069-b7b8-f10c7d90d411",
        "storage_key": "property/6767906449166894/019d08ad-c9f7-7069-b7b8-f10c7d90d411.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7ZxJBxKelVQRUABLtNFeeBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_b3d4fe12-3828-43d7-bd62-621382c0fc73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Walker Stadium - Portland Pickles Baseball",
      "poi_type": "Entertainment",
      "poi_address": "4727 SE 92nd Ave #4601, Portland, OR 97266, USA",
      "poi_short_description": "Clean, laid-back baseball area for summer league games, featuring a snack bar and souvenir booth.",
      "poi_long_description": "People say this stadium offers exciting baseball games featuring young college-age players. They highlight the fun, interactive, and engaging atmosphere, and the friendly people. They also like the left field party and the amazing show put on by the organization.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-2d8b-760f-931e-c8a076008731.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-2d8b-760f-931e-c8a076008731",
        "storage_key": "property/6767906449166894/019d08ae-2d8b-760f-931e-c8a076008731.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://picklesbaseball.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18128420632115444102&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "walker-stadium---portland-pickles-baseball",
      "poi_latitude": "45.488337",
      "poi_longitude": "-122.5695783",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-775-3080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-5f2c-7392-9b79-dfa72abcc51e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-5f2c-7392-9b79-dfa72abcc51e",
        "storage_key": "property/6767906449166894/019d08ae-5f2c-7392-9b79-dfa72abcc51e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy06Q4i-glVQRhnkaNIQWlfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_6a979f48-0ecb-4ddc-91d5-a5878ef13d78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "North Clackamas Aquatic Park",
      "poi_type": "Entertainment",
      "poi_address": "7300 SE Harmony Rd, Milwaukie, OR 97222, USA",
      "poi_short_description": "Wave pool, water slides & other attractions featured at an aquatic center with a rock wall too.",
      "poi_long_description": "People say this water park offers a variety of attractions, including a wave pool, slides, a diving board, and a lap pool. They highlight the reasonable prices and fun, family-friendly vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-2db4-72d6-abaa-6d4b99daac9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-2db4-72d6-abaa-6d4b99daac9b",
        "storage_key": "property/6767906449166894/019d08ae-2db4-72d6-abaa-6d4b99daac9b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ncprd.org/aquatic-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15199232235678458234&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-clackamas-aquatic-park",
      "poi_latitude": "45.4312413",
      "poi_longitude": "-122.5828227",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-557-7873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt77BL551lVQReuFHejCF7tI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_ba3da369-ac84-4832-b574-90b28a058299",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Play Street Museum - Happy Valley",
      "poi_type": "Entertainment",
      "poi_address": "13120 SE 172nd Ave Suite 116, Happy Valley, OR 97086, USA",
      "poi_short_description": "Cozy indoor playground with themed play areas, toys, painting and slime-making activities.",
      "poi_long_description": "People say this children's museum offers a variety of imaginative play options, creative activities, and learning opportunities. They highlight the clean and well-maintained space, and the fun and engaging experience for children. They also like the friendly and helpful staff, and the convenient snack provided at the end of playtime. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-3339-732f-92f8-a90246816fa8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-3339-732f-92f8-a90246816fa8",
        "storage_key": "property/6767906449166894/019d08ae-3339-732f-92f8-a90246816fa8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.happyvalley.playstreetmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17232434653513804753&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "play-street-museum---happy-valley",
      "poi_latitude": "45.428519",
      "poi_longitude": "-122.485262",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-963-6359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-ce52-76c9-bd94-cd355cb99a28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ce52-76c9-bd94-cd355cb99a28",
        "storage_key": "property/6767906449166894/019d08ad-ce52-76c9-bd94-cd355cb99a28.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmyGwxlaflVQR0WvSGQToJe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ce524059-5758-4f89-8a7d-86861c1689d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Historical Downtown Gresham",
      "poi_type": "Entertainment",
      "poi_address": "100 - 400 N Main Ave, Gresham, OR 97080, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-333f-74f2-b683-d44afd75b031.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-333f-74f2-b683-d44afd75b031",
        "storage_key": "property/6767906449166894/019d08ae-333f-74f2-b683-d44afd75b031.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16562479149008839679&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "historical-downtown-gresham",
      "poi_latitude": "45.5007382",
      "poi_longitude": "-122.4321211",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__-PhfKYlVQR_2N8xAi_2eU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_c0bde900-9523-4aa5-a23c-8adf4db2ace1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Oregon Military Museum",
      "poi_type": "Entertainment",
      "poi_address": "15300 Minuteman Way, Clackamas, OR 97015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-34a0-767d-9d05-8519e563f42a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-34a0-767d-9d05-8519e563f42a",
        "storage_key": "property/6767906449166894/019d08ae-34a0-767d-9d05-8519e563f42a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://oregonmilitarymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16769528769218773031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oregon-military-museum",
      "poi_latitude": "45.4111814",
      "poi_longitude": "-122.5588919",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 971-355-2275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-ce52-76c9-bd94-cd355cb99a28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ce52-76c9-bd94-cd355cb99a28",
        "storage_key": "property/6767906449166894/019d08ad-ce52-76c9-bd94-cd355cb99a28.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQcw-Gul1lVQRJ4D6G5FVueg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_56a080f5-f6f0-4803-a2d6-d7515478930e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8720 SE Sunnybrook Blvd, Clackamas, OR 97015, USA",
      "poi_short_description": "Chain fitness center with a pool, steam room, basketball court, and a range of cardio and strength equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-8f69-77b1-8bb1-cd4de471da4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-8f69-77b1-8bb1-cd4de471da4c",
        "storage_key": "property/6767906449166894/019d08ad-8f69-77b1-8bb1-cd4de471da4c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/clackamas-or/clackamas-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=524171730554674393&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "45.4294217",
      "poi_longitude": "-122.573052",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-653-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ78z7gJt1lVQR2VwDaWk7Rgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fd0d099a-33c8-422e-9960-24727f673f7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "VCA Northwest Veterinary Specialists",
      "poi_type": "Health and Wellness",
      "poi_address": "16756 SE 82nd Dr, Clackamas, OR 97015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-3610-756b-8f8f-90662285edf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-3610-756b-8f8f-90662285edf8",
        "storage_key": "property/6767906449166894/019d08ae-3610-756b-8f8f-90662285edf8.webp",
        "width": 980,
        "height": 551
      },
      "poi_business_url": "https://vcahospitals.com/northwest-veterinary-specialists?utm_source=maps&utm_medium=organic&utm_campaign=AU_801",
      "poi_directions_map_url": "https://maps.google.com/?cid=6328674256617790327&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vca-northwest-veterinary-specialists",
      "poi_latitude": "45.400854",
      "poi_longitude": "-122.56804",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-656-3999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZV8iodB1lVQRd9vcpLT301c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_247125e5-dd35-49cc-b2d6-920ac23f18f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10319 SE 82nd Ave, Portland, OR 97266, USA",
      "poi_short_description": "Workout center with cardio machines, locker rooms, and showers, plus friendly staff.",
      "poi_long_description": "People say this gym offers a wide selection of equipment and a large workout space. They highlight the affordable membership, the clean and well-maintained facility, and the relaxing massage chairs. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-39d4-72dc-aab6-136e9584d76a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-39d4-72dc-aab6-136e9584d76a",
        "storage_key": "property/6767906449166894/019d08ae-39d4-72dc-aab6-136e9584d76a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/portland-se-82nd-clackamas-or?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=15805994544599064317&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "45.4481157",
      "poi_longitude": "-122.5802103",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-974-9737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEVxc6o91lVQR_d6WaEssWts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e022f9df-ed60-4061-9777-8098eb265c46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9280 SE Foster Rd, Portland, OR 97266, USA",
      "poi_short_description": "Chain fitness center offering equipment, tanning beds, and hydro massage.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-39d4-72dc-aab6-136e9584d76a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-39d4-72dc-aab6-136e9584d76a",
        "storage_key": "property/6767906449166894/019d08ae-39d4-72dc-aab6-136e9584d76a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/portland-se-foster-rd-or?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=5827786765744949775&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "45.4794029",
      "poi_longitude": "-122.5678453",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-771-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwedoqk6hlVQRD0rzvi914FA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7e0d68d6-41f0-44b7-b200-e393bd0955fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Cascade Athletic Club - Gresham",
      "poi_type": "Health and Wellness",
      "poi_address": "19201 SE Division St, Gresham, OR 97030, USA",
      "poi_short_description": "Spacious family-friendly gym featuring a saltwater pool, a water park and a kids' club.",
      "poi_long_description": "People say this fitness center offers a wide variety of activities, including pickleball, racquetball, tennis, swimming, and water aerobics, as well as a weight room, exercise classes, saunas, and jacuzzis. They highlight the excellent management, maintenance, and necessary upgrades, and the family-friendly atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-3a81-7400-ac4e-87ed553efad6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-3a81-7400-ac4e-87ed553efad6",
        "storage_key": "property/6767906449166894/019d08ae-3a81-7400-ac4e-87ed553efad6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cascadeac.com/gresham",
      "poi_directions_map_url": "https://maps.google.com/?cid=16763921302616666396&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cascade-athletic-club---gresham",
      "poi_latitude": "45.5047844",
      "poi_longitude": "-122.4650436",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-665-4142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSynln5iYlVQRHPERDZtppeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_2760f124-70b9-4d42-b4b7-3cfe477822c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Precision Elite Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "15507 SE For Mor Ct, Clackamas, OR 97015, USA",
      "poi_short_description": "Gymnastics, dance and ninja classes for kids and adults, plus summer camps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-3b47-754b-9c97-770c73258dc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-3b47-754b-9c97-770c73258dc5",
        "storage_key": "property/6767906449166894/019d08ae-3b47-754b-9c97-770c73258dc5.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "http://www.precisionelitegymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17446920755786118993&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "precision-elite-gymnastics",
      "poi_latitude": "45.4098665",
      "poi_longitude": "-122.532181",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-659-0095",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-c9f7-7069-b7b8-f10c7d90d411.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-c9f7-7069-b7b8-f10c7d90d411",
        "storage_key": "property/6767906449166894/019d08ad-c9f7-7069-b7b8-f10c7d90d411.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL54i6v51lVQRUXcFWf3pH_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e317e164-f41d-45d3-a2d0-2040c4e61003",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "12000 SE 82nd Ave Spc L121, Happy Valley, OR 97086, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-3c6d-710e-ae9a-7243d969a3ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-3c6d-710e-ae9a-7243d969a3ce",
        "storage_key": "property/6767906449166894/019d08ae-3c6d-710e-ae9a-7243d969a3ce.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/portland-or-1579",
      "poi_directions_map_url": "https://maps.google.com/?cid=5695622572021160124&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "45.434964",
      "poi_longitude": "-122.5757338",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 971-377-1890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-M7FBd1lVQRvJgEdI3qCk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_aeb75797-3b85-4a5f-8834-7055d79ca9a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2330 SE 182nd Ave, Portland, OR 97233, USA",
      "poi_short_description": "Chain fitness center offering tanning services, as well as massage chairs and hydro massages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-39d4-72dc-aab6-136e9584d76a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-39d4-72dc-aab6-136e9584d76a",
        "storage_key": "property/6767906449166894/019d08ae-39d4-72dc-aab6-136e9584d76a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/portland-se-182-or?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13536054168041598363&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "45.5057622",
      "poi_longitude": "-122.4747274",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-912-3572",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxcvOyaCYlVQRm62Qeoy52bs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c44ed4b6-f5e4-437a-a56e-f1d515aefb31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "839 NW 12th St, Gresham, OR 97030, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-3c6d-710e-ae9a-7243d969a3ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-3c6d-710e-ae9a-7243d969a3ce",
        "storage_key": "property/6767906449166894/019d08ae-3c6d-710e-ae9a-7243d969a3ce.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/gresham-or-322",
      "poi_directions_map_url": "https://maps.google.com/?cid=722806829508198065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "45.506105",
      "poi_longitude": "-122.4414779",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-665-6838",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5_mJo-YlVQRsf4PWvvsBwo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_e1ffc515-bdaf-46e2-84b7-f1e9dcc4e0eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Crunch Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12112 SE Division St, Portland, OR 97236, USA",
      "poi_short_description": "No-frills fitness business offering personal training and an array of classes like kickboxing and Zumba, plus friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-40c3-7630-8c5a-aa8d9ed673d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-40c3-7630-8c5a-aa8d9ed673d2",
        "storage_key": "property/6767906449166894/019d08ae-40c3-7630-8c5a-aa8d9ed673d2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/division",
      "poi_directions_map_url": "https://maps.google.com/?cid=16468800013169091090&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness",
      "poi_latitude": "45.5029001",
      "poi_longitude": "-122.5387956",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 503-227-8624",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbfaD8sGhlVQREmLkRVvujOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e80b8d3d-2dd7-481b-9764-7a7095a3fe24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Kaiser Permanente Sunnyside Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10180 SE Sunnyside Rd, Clackamas, OR 97015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-8833-7327-83e4-c868cd9dc3d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-8833-7327-83e4-c868cd9dc3d3",
        "storage_key": "property/6767906449166894/019d08ad-8833-7327-83e4-c868cd9dc3d3.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://healthy.kaiserpermanente.org/oregon-washington/facilities/Kaiser-Permanente-Sunnyside-Medical-Center-100249",
      "poi_directions_map_url": "https://maps.google.com/?cid=10088258469650416852&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaiser-permanente-sunnyside-medical-center",
      "poi_latitude": "45.4314111",
      "poi_longitude": "-122.5602391",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-813-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d413-727f-a07f-d2325df673b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d413-727f-a07f-d2325df673b5",
        "storage_key": "property/6767906449166894/019d08ad-d413-727f-a07f-d2325df673b5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJXUrKgYZ1lVQR1MTW1aCxAIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_21c3b3c8-2cb9-4371-8c1b-c49177d2884f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Back In Shape Chiropractic",
      "poi_type": "Health and Wellness",
      "poi_address": "6501 SE King Rd, Milwaukie, OR 97222, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-4261-724b-a8af-7635437ecc11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-4261-724b-a8af-7635437ecc11",
        "storage_key": "property/6767906449166894/019d08ae-4261-724b-a8af-7635437ecc11.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.chiropractormilwaukieoregon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7230037596656977418&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "back-in-shape-chiropractic",
      "poi_latitude": "45.448127",
      "poi_longitude": "-122.5959315",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-788-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d413-727f-a07f-d2325df673b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d413-727f-a07f-d2325df673b5",
        "storage_key": "property/6767906449166894/019d08ad-d413-727f-a07f-d2325df673b5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJEQ04LGh1lVQRCkZ1ReNAVmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0f066947-8df2-4f06-b72f-32a01fc312ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Powell Butte Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16160 SE Powell Blvd, Portland, OR 97236, USA",
      "poi_short_description": "Family-friendly natural area with plenty of hiking, biking & equestrian trails among scenic vistas.",
      "poi_long_description": "Visitors say this nature park offers a variety of hiking trails, with options for all levels, and stunning views of the city and mountains. They also highlight that it's a great place to walk dogs, with plenty of space and well-maintained trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-983b-7707-85ab-be987c223194.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-983b-7707-85ab-be987c223194",
        "storage_key": "property/6767906449166894/019d08ad-983b-7707-85ab-be987c223194.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.portlandoregon.gov/parks/finder/index.cfm?action=ViewPark&PropertyID=528",
      "poi_directions_map_url": "https://maps.google.com/?cid=11785825895941029343&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "powell-butte-nature-park",
      "poi_latitude": "45.4906961",
      "poi_longitude": "-122.4969916",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-ce22-767b-83cb-0a9d97aec971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ce22-767b-83cb-0a9d97aec971",
        "storage_key": "property/6767906449166894/019d08ad-ce22-767b-83cb-0a9d97aec971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEd07m0SflVQR3z0qWDWqj6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f718eb3d-fa06-4d7a-b168-f150fb1afc90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Happy Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13770 SE Ridgecrest Rd, Happy Valley, OR 97086, USA",
      "poi_short_description": "Summer concerts lure locals to this green locale boasting multiple picnic shelters & sports spaces.",
      "poi_long_description": "People say this park offers a variety of amenities, including playgrounds, a splash pad, tennis courts, basketball courts, a skate park, and a dog park. They highlight the park's spaciousness, well-maintained trails, and inclusive play structures suitable for all abilities. They also like the lively and festive vibe, especially during events, and the clean restrooms and convenient parking. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-7670-7681-8286-2e10ae3f14f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-7670-7681-8286-2e10ae3f14f5",
        "storage_key": "property/6767906449166894/019d08ad-7670-7681-8286-2e10ae3f14f5.webp",
        "width": 1280,
        "height": 675
      },
      "poi_business_url": "http://www.happyvalleyor.gov/?NID=143",
      "poi_directions_map_url": "https://maps.google.com/?cid=2162196277840598281&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "happy-valley-park",
      "poi_latitude": "45.4518711",
      "poi_longitude": "-122.5214409",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-783-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-ce22-767b-83cb-0a9d97aec971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ce22-767b-83cb-0a9d97aec971",
        "storage_key": "property/6767906449166894/019d08ad-ce22-767b-83cb-0a9d97aec971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz_wLqzSelVQRCVVcEw-qAR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_933bd42e-32b2-48db-b00d-c622e0d3ea33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Lents Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4808 SE 92nd Ave, Portland, OR 97266, USA",
      "poi_short_description": "Large park with baseball, soccer, tennis & basketball, plus a playground & plenty of open space.",
      "poi_long_description": "People say this city park offers a playground, sports fields, and a jogging path. They also highlight the spacious green areas, the modern playground, and the welcoming atmosphere.\n\nOther reviews mention the park can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-44de-76ba-bf47-42e5eddb1d1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-44de-76ba-bf47-42e5eddb1d1f",
        "storage_key": "property/6767906449166894/019d08ae-44de-76ba-bf47-42e5eddb1d1f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.portlandoregon.gov/parks/finder/index.cfm?&propertyid=234&action=viewpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=11775586500131088060&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lents-park",
      "poi_latitude": "45.4872904",
      "poi_longitude": "-122.5704073",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-823-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-ce22-767b-83cb-0a9d97aec971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ce22-767b-83cb-0a9d97aec971",
        "storage_key": "property/6767906449166894/019d08ad-ce22-767b-83cb-0a9d97aec971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm2FdWiWglVQRvOYyOohJa6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_68912b97-8684-42b2-952b-3c8550aa3c47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Leach Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6704 SE 122nd Ave, Portland, OR 97236, USA",
      "poi_short_description": "Estate featuring a manor house, 2,000+ plant species, classes & trails for nature walks.",
      "poi_long_description": "People say this botanical garden offers a variety of areas to explore, including a pollinator garden, meadow, forested area with a creek, and an elevated tree walk. They highlight the peaceful and tranquil atmosphere, and the affordable entrance fee. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-9975-758e-9119-8493405b2f25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-9975-758e-9119-8493405b2f25",
        "storage_key": "property/6767906449166894/019d08ad-9975-758e-9119-8493405b2f25.webp",
        "width": 868,
        "height": 823
      },
      "poi_business_url": "http://leachgarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5999375557505503110&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "leach-botanical-garden",
      "poi_latitude": "45.475173",
      "poi_longitude": "-122.5356262",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-208-6030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-ce22-767b-83cb-0a9d97aec971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ce22-767b-83cb-0a9d97aec971",
        "storage_key": "property/6767906449166894/019d08ad-ce22-767b-83cb-0a9d97aec971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ10f5iJ2flVQRhs9Gk0gQQlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_bf4de471-49cd-406f-8ac1-539f265aacad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Carver Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14888 S Springwater Rd, Oregon City, OR 97045, USA",
      "poi_short_description": "Neighborhood picnic area with boat ramp & fishing access; fee parking lot on-site.",
      "poi_long_description": "People say this park offers beautiful river views and access to the Clackamas River, as well as great fishing and river activities. They also highlight the clean boat ramp and bathrooms, and the safe environment for children.\n\nOther reviews mention parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-4651-72f8-8252-5aad1358ebb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-4651-72f8-8252-5aad1358ebb2",
        "storage_key": "property/6767906449166894/019d08ae-4651-72f8-8252-5aad1358ebb2.webp",
        "width": 711,
        "height": 400
      },
      "poi_business_url": "http://www.clackamas.us/parks/carver.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13735236866331357708&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "carver-park",
      "poi_latitude": "45.3918044",
      "poi_longitude": "-122.4947971",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-742-4414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-ce22-767b-83cb-0a9d97aec971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-ce22-767b-83cb-0a9d97aec971",
        "storage_key": "property/6767906449166894/019d08ad-ce22-767b-83cb-0a9d97aec971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-31ExIudlVQRDLKHUyhdnb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_56c20ce6-8f5c-447c-a3fb-b427b955bd36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Clackamas Town Center TC",
      "poi_type": "Transportation & Transit",
      "poi_address": "Oregon 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-47c9-7014-8578-c390daa9b026.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-47c9-7014-8578-c390daa9b026",
        "storage_key": "property/6767906449166894/019d08ae-47c9-7014-8578-c390daa9b026.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://trimet.org/#tracker/stop/13132",
      "poi_directions_map_url": "https://maps.google.com/?cid=8016725510793434420&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clackamas-town-center-tc",
      "poi_latitude": "45.4358443",
      "poi_longitude": "-122.5678091",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTVsWG4J1lVQRNJWnrGAhQW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_30f27896-7ef0-4e88-8ece-754ab49f43d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Gresham Central TC MAX",
      "poi_type": "Transportation & Transit",
      "poi_address": "Gresham, OR 97030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-495e-773f-85ed-96f21a1dcc2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-495e-773f-85ed-96f21a1dcc2c",
        "storage_key": "property/6767906449166894/019d08ae-495e-773f-85ed-96f21a1dcc2c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2049655610492547269&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gresham-central-tc-max",
      "poi_latitude": "45.5026552",
      "poi_longitude": "-122.427018",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR_1Cq4qYlVQRxXBLD-vWcRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_0d42d754-f5cf-4e7f-b6b0-db48223ceb2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "SE Holgate Blvd MAX Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Portland, OR 97266, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-4c06-774e-bcf1-c3fcc2c9ef6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-4c06-774e-bcf1-c3fcc2c9ef6c",
        "storage_key": "property/6767906449166894/019d08ae-4c06-774e-bcf1-c3fcc2c9ef6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trimet.org/ride/m/stop.html?stop_id=13136",
      "poi_directions_map_url": "https://maps.google.com/?cid=9597660068286196527&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "se-holgate-blvd-max-station",
      "poi_latitude": "45.491118",
      "poi_longitude": "-122.566272",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDxG8iDGglVQRL2smRfu8MYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_714619f0-b1ba-420d-a7d7-01c4fb18f356",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Lents Town Center/SE Foster Rd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Portland, OR 97266, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-4de4-7649-9c14-cfc6ebf5a743.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-4de4-7649-9c14-cfc6ebf5a743",
        "storage_key": "property/6767906449166894/019d08ae-4de4-7649-9c14-cfc6ebf5a743.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3633832530777153971&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lents-town-centerse-foster-rd",
      "poi_latitude": "45.48043699999999",
      "poi_longitude": "-122.566808",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5657ESeglVQRsyE7Em_3bTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_aefe6f89-6abc-4cd2-8385-21d429bfe6ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "SE Flavel Street",
      "poi_type": "Transportation & Transit",
      "poi_address": "Portland, OR 97266, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-4f3f-772b-8450-dc0cb96d31fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-4f3f-772b-8450-dc0cb96d31fd",
        "storage_key": "property/6767906449166894/019d08ae-4f3f-772b-8450-dc0cb96d31fd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=389557377073245758&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "se-flavel-street",
      "poi_latitude": "45.467835",
      "poi_longitude": "-122.566652",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz6t4d-2flVQRPm4V2F78ZwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_22ccdd81-8ae5-4f97-abc4-420444b99553",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Bob's Red Mill Natural Foods - Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13521 SE Pheasant Ct, Milwaukie, OR 97222, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-b8c9-717a-9dd9-fb08e6ab61f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-b8c9-717a-9dd9-fb08e6ab61f0",
        "storage_key": "property/6767906449166894/019d08ad-b8c9-717a-9dd9-fb08e6ab61f0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bobsredmill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15370631250476380702&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bobs-red-mill-natural-foods---headquarters",
      "poi_latitude": "45.4257714",
      "poi_longitude": "-122.5911032",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-349-2173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2wOR2aZ1lVQRHrIpaq9zT9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_67d8b464-3d1b-4ec3-893a-47b4d823947b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Gresham City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1333 NW Eastman Pkwy, Gresham, OR 97030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-52d0-73fa-b47b-d3c5af216aad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-52d0-73fa-b47b-d3c5af216aad",
        "storage_key": "property/6767906449166894/019d08ae-52d0-73fa-b47b-d3c5af216aad.webp",
        "width": 588,
        "height": 1280
      },
      "poi_business_url": "http://greshamoregon.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7415945332283216741&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gresham-city-hall",
      "poi_latitude": "45.5069294",
      "poi_longitude": "-122.4359844",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 503-661-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-da75-7203-bbaf-b07d28f49e91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-da75-7203-bbaf-b07d28f49e91",
        "storage_key": "property/6767906449166894/019d08ad-da75-7203-bbaf-b07d28f49e91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46LzBomYlVQRZRN1BP266mY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_3fc7adeb-896f-4422-966b-e03fd10536f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "AMR Clackamas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12438 SE Capps Rd, Clackamas, OR 97015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://amr.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=340493641015248353&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amr-clackamas",
      "poi_latitude": "45.39873100000001",
      "poi_longitude": "-122.534627",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVzodg53lVQR4UX-mCmtuQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f58f3479-2628-46a3-b0b9-26271fdb982b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Happy Valley City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "16000 SE Misty Dr, Happy Valley, OR 97086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-53db-751b-9a98-2d6ada04667d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-53db-751b-9a98-2d6ada04667d",
        "storage_key": "property/6767906449166894/019d08ae-53db-751b-9a98-2d6ada04667d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.happyvalleyor.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16097911516973870240&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "happy-valley-city-hall",
      "poi_latitude": "45.4294153",
      "poi_longitude": "-122.4974471",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-783-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-da75-7203-bbaf-b07d28f49e91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-da75-7203-bbaf-b07d28f49e91",
        "storage_key": "property/6767906449166894/019d08ad-da75-7203-bbaf-b07d28f49e91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ91JVl2-elVQRoKzl-jtFZ98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_f150ff0c-1fef-4650-b6e5-eb618bd660e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "poi_name": "Safeway Distribution Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "16300 SE Evelyn St, Clackamas, OR 97015, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ae-5528-72cb-b153-c54a0e11e057.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-5528-72cb-b153-c54a0e11e057",
        "storage_key": "property/6767906449166894/019d08ae-5528-72cb-b153-c54a0e11e057.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.safeway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10449127469962101711&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "safeway-distribution-center",
      "poi_latitude": "45.4036292",
      "poi_longitude": "-122.5621539",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-305-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb",
        "storage_key": "property/6767906449166894/019d08ad-d39d-76bf-a9b5-8a4c0ec46fcb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Rx_h9t1lVQRzwPecxLCApE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_be891669-7737-49b1-b823-a63f9eb256c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_9f93dd19-fd29-4212-800f-ff475b2093ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_7760cfd7-4120-44e9-a23d-505ae0e02b85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_a6d02b0a-7c32-4324-81d9-6a7a09b7cd21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_2cdfd458-d08e-4203-8db9-70b6d41a8f10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_6347eebf-89a3-47c1-8b06-2731857da049",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_2e101d12-c196-4481-a797-9f7d33df3962",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_ac1ae409-82c5-454a-982b-b22499778080",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "rating": "5.0",
      "name": "Yamilex Lopez",
      "text": "Been here for a year now and we are enjoying the community. We’ve had issues with our washer and maintenance was always quick to come and take care of it which I really appreciate. The office staff is friendly. Only issue is upstairs neighbors with kids who are always stomping around but alas, that is apartment living.",
      "date": "2025-04-30",
      "title": ""
    },
    {
      "id": "custom_e90cfb9c-8b01-42ca-bd0a-38b063f17604",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "rating": "5.0",
      "name": "Jessica Duncan",
      "text": "The staff at Heather Lodge is hands down the best I’ve worked with so far (and I move A LOT)! Tamar got me started and worked with me to get me into a home on super short notice. After move-in I met Dirk the maintenance supervisor and it’s people like Dirk that make an experience excellent! He has been incredibly helpful since day 1, and makes it a point to get to know “his community” and is genuinely a great person. I’d recommend this community to anyone!",
      "date": "2021-08-25",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_db146521-5b0c-4596-9913-d469ea738787",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d2bea-240c-77af-8de7-7468a9d31c97.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2bea-240c-77af-8de7-7468a9d31c97",
        "storage_key": "property/6767906449166894/019d2bea-240c-77af-8de7-7468a9d31c97.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Heather Lodge Apartments - 1 Bedroom 1 Bath 675 sq. ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=4798wtR2txi"
    },
    {
      "id": "custom_81df3dad-7aa2-4dff-bd70-1e84a3f6be83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d2bea-3e89-714d-9f5e-97ee71d977f1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2bea-3e89-714d-9f5e-97ee71d977f1",
        "storage_key": "property/6767906449166894/019d2bea-3e89-714d-9f5e-97ee71d977f1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Heather Lodge Apartments - 2 Bedroom 2 Bath 1034 sq. ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CzGX2tQGfVV"
    },
    {
      "id": "custom_db9cd4b2-1901-479f-9226-90f92752a5e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d2bea-5c13-71c5-ab0f-7e397f351720.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2bea-5c13-71c5-ab0f-7e397f351720",
        "storage_key": "property/6767906449166894/019d2bea-5c13-71c5-ab0f-7e397f351720.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Heather Lodge Apartments - 3 Bedroom 2 Bath 1,232 sq. ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=EL2ZFMSsR6V"
    },
    {
      "id": "custom_12e27ec8-ae9a-40c9-b781-2be46a65ad49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d2bea-7372-72d4-8eed-4c9f804baa41.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2bea-7372-72d4-8eed-4c9f804baa41",
        "storage_key": "property/6767906449166894/019d2bea-7372-72d4-8eed-4c9f804baa41.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Heather Lodge Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=LggTgP9uHaa"
    },
    {
      "id": "custom_bdcaccdc-444e-4c9c-9bf4-48235ed9d61c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166894/019d2bea-8d11-757b-b52f-284976ecfe30.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2bea-8d11-757b-b52f-284976ecfe30",
        "storage_key": "property/6767906449166894/019d2bea-8d11-757b-b52f-284976ecfe30.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Heather Lodge Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mfe8QfvznPr"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1a8-cee0-746d-a8a8-4909c8d54b0c",
      "lead_source": "LANDING_PAGE",
      "name": "Heather Lodge Apartments Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-happy-valley-or",
      "search_query": "fitness center apartments Happy Valley OR",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Happy Valley, OR",
      "h2_subtitle": "Looking for fitness center apartments in Happy Valley, OR? Heather Lodge offers a state-of-the-art fully equipped fitness center.",
      "page_copy": "Discover the active lifestyle waiting for you at Heather Lodge, your premiere choice for fitness center apartments in Happy Valley, OR. Our fully equipped fitness center is designed to cater to all your workout needs, offering a variety of equipment to help you stay in shape without ever leaving the comfort of your community. Conveniently located in beautiful Happy Valley, living at Heather Lodge also provides access to the scenic Rock Creek neighborhood.\n\nResidents of Heather Lodge enjoy more than just fitness amenities. The seasonal swimming pool offers a refreshing oasis during warmer months, while the resident clubhouse stands ready as an entertaining venue with games and a cozy fireside lounge. Combine these features with our prime location in Clackamas County, and you'll find that Heather Lodge provides the perfect blend of comfort, convenience, and lifestyle enhancement.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments | Heather Lodge OR",
      "seo_description": "Heather Lodge in Happy Valley, OR offers apartments with a state-of-the-art fitness center for an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "apartments-with-pool-clackamas-county",
      "search_query": "apartments with a pool in Clackamas County",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Clackamas County",
      "h2_subtitle": "Searching for apartments with a pool in Clackamas County? Heather Lodge offers a seasonal swimming pool perfect for relaxation and enjoyment.",
      "page_copy": "Experience luxurious living at Heather Lodge, where you can find premier apartments with a pool in Clackamas County. Nestled in the picturesque Rock Creek neighborhood, our seasonal swimming pool provides a stunning spot to soak up the sun or enjoy a refreshing swim. Whether you're looking to unwind on the weekend or escape the summer heat, our pool area is designed with your comfort in mind.\n\nIn addition to our sparkling pool, Heather Lodge offers an array of amenities that elevate your living experience. The resident clubhouse is ideal for hosting gatherings, featuring games and a fireside lounge perfect for cozy evenings. Plus, our fully equipped fitness center invites you to maintain an active lifestyle right at home. Located in Happy Valley, OR, Heather Lodge perfectly combines convenience and relaxation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments | Heather Lodge Clackamas County",
      "seo_description": "Discover Heather Lodge in Clackamas County, offering stylish apartments with a seasonal pool for leisure and relaxation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "luxury-apartments-clubhouse-happy-valley",
      "search_query": "luxury apartments with a clubhouse Happy Valley",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with a Clubhouse in Happy Valley",
      "h2_subtitle": "Explore luxury apartments with a clubhouse in Happy Valley. Heather Lodge features a resident clubhouse with games and a fireside lounge.",
      "page_copy": "Indulge in sophisticated living at Heather Lodge, offering luxury apartments with a clubhouse right in Happy Valley. Designed for those who value both style and function, our community boasts a resident clubhouse that serves as the heart of social activities. With games and a cozy fireside lounge, it's the perfect spot to gather with neighbors or host friends.\n\nAlongside the clubhouse, Heather Lodge provides an array of upscale amenities that enhance your lifestyle. From our fully equipped fitness center to the refreshing seasonal swimming pool and spa, every aspect of our community is crafted with your comfort in mind. Situated in the serene Rock Creek area of Clackamas County, Heather Lodge positions you perfectly for urban convenience and natural beauty.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Clubhouse Apartments | Heather Lodge OR",
      "seo_description": "Heather Lodge in Happy Valley offers luxury apartments featuring a stylish clubhouse ideal for social gatherings and relaxation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "spa-pool-apartments-rock-creek",
      "search_query": "spa and pool apartments Rock Creek",
      "category": "Amenity",
      "h1_title": "Spa and Pool Apartments in Rock Creek",
      "h2_subtitle": "Discover spa and pool apartments in Rock Creek at Heather Lodge. Enjoy year-round relaxation and leisure right at home.",
      "page_copy": "Heather Lodge offers the perfect retreat with its spa and pool apartments located in the scenic Rock Creek neighborhood. Our seasonal swimming pool and refreshing spa are designed to deliver the ultimate in leisure and relaxation. Whether you're unwinding after a long day or seeking a weekend reprieve, these amenities provide a serene escape from everyday life.\n\nLiving at Heather Lodge also grants you access to a fully equipped fitness center, ensuring you stay active alongside enjoying our water features. The resident clubhouse with a cozy fireside lounge and games further enhances your living experience, providing a dynamic social hub within the community. Nestled in Happy Valley, OR, our community combines ease and elegance in a prime location within Clackamas County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spa and Pool Apartments | Heather Lodge OR",
      "seo_description": "Experience leisure at Heather Lodge in Rock Creek with apartments featuring a seasonal spa and pool for ultimate relaxation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-clackamas-county",
      "search_query": "pet friendly apartments in Clackamas County",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Clackamas County",
      "h2_subtitle": "Search no further for pet friendly apartments in Clackamas County. Heather Lodge warmly welcomes you and your furry friends.",
      "page_copy": "Welcome to Heather Lodge, where we proudly offer pet friendly apartments in Clackamas County. Our community embraces the joy of pet companionship, ensuring both you and your furry friends feel right at home. Designed with pets in mind, our open spaces and convenient location offer plenty of opportunities for daily walks and outdoor adventures.\n\nApart from being a haven for pets, Heather Lodge provides exceptional amenities for our human residents. Enjoy a fully equipped fitness center to stay active, or take a dip in our seasonal swimming pool. The resident clubhouse, complete with games and a fireside lounge, offers a cozy setting for socializing or relaxing after a day spent exploring the Rock Creek neighborhood. Located in Happy Valley, OR, Heather Lodge is the perfect blend of comfort and convenience for all.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Living | Heather Lodge Clackamas County",
      "seo_description": "Heather Lodge offers pet friendly apartments in Clackamas County with spacious living and welcoming amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "studio-apartments-near-rock-creek",
      "search_query": "studio apartments near Rock Creek",
      "category": "Floorplan",
      "h1_title": "Studio Apartments Near Rock Creek",
      "h2_subtitle": "Find studio apartments near Rock Creek at Heather Lodge. Enjoy modern living with access to premium amenities in a beautiful setting.",
      "page_copy": "Heather Lodge offers contemporary studio apartments near Rock Creek, designed for comfort and convenience. Our studios provide efficient layouts with modern finishes, perfect for those seeking a streamlined living space in the heart of Happy Valley. With Rock Creek's scenic surroundings just steps away, residents can enjoy a blend of urban convenience and natural tranquility.\n\nAt Heather Lodge, you'll not only cherish your studio apartment but also the various amenities that come with it. Dive into relaxation at our seasonal swimming pool and spa or maintain your fitness regimen at our state-of-the-art fitness center. Socialize and unwind in our resident clubhouse, featuring games and a cozy fireside lounge. Experience the vibrant lifestyle that awaits in Clackamas County, OR, at Heather Lodge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments Near Rock Creek | Heather Lodge",
      "seo_description": "Discover modern studio apartments near Rock Creek at Heather Lodge featuring upscale amenities and a convenient location in Happy Valley, OR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-happy-valley-or",
      "search_query": "1 bedroom apartments in Happy Valley OR",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Happy Valley, OR",
      "h2_subtitle": "Explore 1 bedroom apartments in Happy Valley, OR at Heather Lodge. Experience comfort and convenience in a thriving community.",
      "page_copy": "Discover the ideal one-bedroom apartments at Heather Lodge in Happy Valley, OR. Our thoughtfully designed layouts offer spacious living areas and modern amenities that cater to your lifestyle needs. Situated in the charming Rock Creek neighborhood, this community provides a serene setting while keeping you close to local conveniences and attractions.\n\nResidents at Heather Lodge enjoy a wealth of amenities that enhance daily living. Take advantage of our fully equipped fitness center or relax in the seasonal swimming pool and spa. The resident clubhouse, with its games and welcoming fireside lounge, offers the perfect place to socialize and meet neighbors. Embrace the opportunity to enjoy elegant living in Clackamas County, where urban convenience meets peaceful surroundings.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments | Heather Lodge Happy Valley OR",
      "seo_description": "Find spacious 1 bedroom apartments in Happy Valley, OR at Heather Lodge with modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-in-clackamas-county",
      "search_query": "2 bedroom apartments in Clackamas County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Clackamas County",
      "h2_subtitle": "Discover spacious 2 bedroom apartments in Clackamas County at Heather Lodge. Enjoy comfort and modern amenities in a prime location.",
      "page_copy": "Heather Lodge invites you to explore our spacious 2 bedroom apartments in Clackamas County. Ideal for families or roommates, these well-designed homes offer ample living space with stylish features and contemporary finishes. Nestled in the vibrant Rock Creek neighborhood, our community ensures you're never far from local shops and delightful dining options in Happy Valley, OR.\n\nOur residents enjoy a range of amenities that make Heather Lodge stand out. Stay active in the fully equipped fitness center or unwind in our seasonal swimming pool and spa. The resident clubhouse provides a perfect gathering spot with games and a cozy fireside lounge. Live in the comfort of a welcoming community that balances convenience with a touch of tranquility at Heather Lodge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments | Heather Lodge Clackamas County",
      "seo_description": "Find your ideal 2 bedroom apartment in Clackamas County at Heather Lodge with top-notch amenities and a friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-97015",
      "search_query": "3 bedroom apartments near 97015",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 97015",
      "h2_subtitle": "Explore spacious 3 bedroom apartments near the 97015 ZIP code at Heather Lodge. Enjoy a premium living experience with family-friendly amenities.",
      "page_copy": "Experience the perfect blend of space and style with our 3 bedroom apartments near the 97015 area at Heather Lodge. These generously sized homes are ideal for families or those needing extra room. Located in the charming Rock Creek neighborhood in Happy Valley, OR, our apartments provide a peaceful retreat while keeping you connected to the local community.\n\nHeather Lodge offers an exceptional living experience with a host of amenities designed to elevate your lifestyle. Stay fit in our state-of-the-art fitness center, relax by the seasonal swimming pool and spa, or enjoy a fun evening in our resident clubhouse with games and a cozy fireside lounge. Embrace the opportunity to call our welcoming community home in Clackamas County, where you're always close to conveniences and natural beauty.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments | Heather Lodge Near 97015",
      "seo_description": "Find spacious 3 bedroom apartments near the 97015 zip code at Heather Lodge with modern amenities and a family-friendly atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "apartments-near-kaiser-permanente-sunnyside",
      "search_query": "apartments near kaiser permanente sunnyside medical center happy valley",
      "category": "Hospital",
      "h1_title": "Apartments Near Kaiser Permanente Sunnyside",
      "h2_subtitle": "Discover convenient apartments near Kaiser Permanente Sunnyside Medical Center in Happy Valley. Experience comfortable living close to healthcare services.",
      "page_copy": "Heather Lodge offers a prime living experience with our apartments near Kaiser Permanente Sunnyside Medical Center in Happy Valley. Conveniently located in the Rock Creek neighborhood, our community provides easy access to healthcare services while maintaining the tranquility of suburban living.\n\nOur residents enjoy top-notch amenities that make Heather Lodge a place you're proud to call home. Whether you're staying fit in our fully equipped fitness center or unwinding in the seasonal swimming pool and spa, there's something for everyone. The resident clubhouse offers a cozy fireside lounge and games, perfect for relaxation and socializing. Embrace the comfort and convenience of Heather Lodge, where quality living meets a prime location close to essential services in Clackamas County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kaiser Permanente Sunnyside OR",
      "seo_description": "Find comfortable apartments near Kaiser Permanente Sunnyside Medical Center in Happy Valley at Heather Lodge, offering great amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "heather-lodge-near-back-in-shape-chiropractic",
      "search_query": "heather lodge apartments close to back in shape chiropractic clackamas county",
      "category": "Hospital",
      "h1_title": "Heather Lodge Near Back In Shape Chiropractic",
      "h2_subtitle": "Heather Lodge offers prime apartments close to Back In Shape Chiropractic in Clackamas County, providing convenience and comfort for your lifestyle.",
      "page_copy": "Located in the welcoming Rock Creek neighborhood, Heather Lodge provides comfortable apartments close to Back In Shape Chiropractic in Clackamas County. Our community is well-situated, ensuring easy access to chiropractic care and the charming amenities of Happy Valley, OR. Enjoy the perfect balance of convenience and comfort right at your doorstep.\n\nAt Heather Lodge, residents can take advantage of superior amenities that enhance everyday living. Join friends in the resident clubhouse, which features games and a cozy fireside lounge, or focus on personal health in our fully equipped fitness center. During the warmer months, relax at our seasonal swimming pool and spa. Embrace the seamless lifestyle Heather Lodge offers, where community, comfort, and convenience blend effortlessly.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Heather Lodge Apartments Near Back In Shape Chiropractic",
      "seo_description": "Discover comfortable living at Heather Lodge, close to Back In Shape Chiropractic in Clackamas County, offering great amenities in Happy Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "apartments-near-powell-butte-nature-park-or",
      "search_query": "apartments near powell butte nature park or",
      "category": "Park",
      "h1_title": "Apartments Near Powell Butte Nature Park OR",
      "h2_subtitle": "Explore apartments near Powell Butte Nature Park, OR, at Heather Lodge. Embrace natural beauty and modern convenience in Happy Valley.",
      "page_copy": "Heather Lodge proudly offers a wonderful living environment with apartments near Powell Butte Nature Park, OR. Nestled in the picturesque Rock Creek neighborhood of Happy Valley, our community invites you to enjoy the natural beauty and outdoor activities just moments from your doorstep. Revel in the opportunity to explore hiking trails and scenic views while living in a comfortable and inviting apartment.\n\nOur residents benefit from a range of amenities designed to enhance life's pleasures. Whether you’re staying active at our fully equipped fitness center, unwinding by the seasonal swimming pool and spa, or socializing in the resident clubhouse's fireside lounge, Heather Lodge provides a welcoming retreat. Discover the perfect blend of natural splendor and community-focused living in Clackamas County at Heather Lodge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Heather Lodge Apartments Near Powell Butte Nature Park",
      "seo_description": "Live near Powell Butte Nature Park OR at Heather Lodge, offering apartments with exceptional amenities and a prime location in Happy Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "apartments-close-to-happy-valley-park-clackamas",
      "search_query": "apartments close to happy valley park clackamas county",
      "category": "Park",
      "h1_title": "Apartments Close to Happy Valley Park",
      "h2_subtitle": "Find apartments close to Happy Valley Park in Clackamas County at Heather Lodge. Experience park-side living with modern amenities.",
      "page_copy": "Heather Lodge offers exceptional apartments close to Happy Valley Park in Clackamas County, providing an ideal setting for enjoying outdoor activities and serene park views. Situated in the friendly Rock Creek neighborhood, our community is perfect for those who love the tranquility of nature combined with the comforts of modern living.\n\nAt Heather Lodge, residents can indulge in top-tier amenities. From the fully equipped fitness center to the seasonal swimming pool and spa, you'll find countless ways to relax and stay fit. The resident clubhouse, featuring a cozy fireside lounge and games, is ideal for meeting neighbors and unwinding. Experience vibrant community living within reach of nature at Heather Lodge, where Happy Valley Park is just a stroll away.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Happy Valley Park Clackamas County",
      "seo_description": "Discover Heather Lodge apartments near Happy Valley Park in Clackamas County, offering a prime location and exceptional amenities in Happy Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "lents-park-apartments-rock-creek",
      "search_query": "lents park apartments rock creek",
      "category": "Park",
      "h1_title": "Lents Park Apartments in Rock Creek",
      "h2_subtitle": "Explore Lents Park apartments at Heather Lodge, located in Rock Creek. Enjoy vibrant community living near natural attractions.",
      "page_copy": "Heather Lodge is your destination for Lents Park apartments in the charming Rock Creek neighborhood. Offering a unique blend of community spirit and access to nature, our apartments provide an ideal home for those seeking balance and convenience. Experience living near stunning natural features, all within reach of lively urban amenities.\n\nResidents at Heather Lodge can enjoy an array of community amenities designed to enhance their lifestyle. Whether you're working out in the fully equipped fitness center, basking by the seasonal swimming pool and spa, or socializing in the resident clubhouse with its cozy fireside lounge, you’ll find a sense of belonging. Embrace life amidst the scenic views and sunny vibes of Happy Valley, OR, with the added benefit of proximity to both Rock Creek and Lents Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lents Park Apartments in Rock Creek at Heather Lodge",
      "seo_description": "Find Lents Park apartments in Rock Creek at Heather Lodge. Offering modern living with great amenities and access to natural attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "leach-botanical-garden-apartments-97015",
      "search_query": "leach botanical garden apartments 97015",
      "category": "Park",
      "h1_title": "Leach Botanical Garden Apartments in 97015",
      "h2_subtitle": "Discover apartments near Leach Botanical Garden, zip code 97015, at Heather Lodge. Enjoy nature-inspired living in Happy Valley.",
      "page_copy": "Experience the charm of nature-inspired living at Heather Lodge, where you'll find exceptional apartments near Leach Botanical Garden in the 97015 area. Positioned in the serene Rock Creek neighborhood of Happy Valley, Heather Lodge offers a harmonious blend of lush surroundings and contemporary amenities. Our community provides a peaceful retreat for those who appreciate proximity to exquisite natural attractions.\n\nEnjoy a variety of amenities that complement your lifestyle, including a fully equipped fitness center, a seasonal swimming pool and spa, and a welcoming resident clubhouse featuring a cozy fireside lounge. These features create an inviting and vibrant environment for residents. Choose Heather Lodge for a unique living experience that combines the beauty of nature with the convenience of modern living, just a stone's throw from Leach Botanical Garden.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Leach Botanical Garden Apartments in 97015 Heather Lodge",
      "seo_description": "Discover Heather Lodge, offering apartments near Leach Botanical Garden in 97015. Enjoy modern amenities and a prime location in Happy Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "apartments-by-carver-park-happy-valley",
      "search_query": "apartments by carver park happy valley",
      "category": "Park",
      "h1_title": "Apartments by Carver Park, Happy Valley",
      "h2_subtitle": "Find the perfect home near Carver Park in Happy Valley at Heather Lodge. Enjoy nature and amenities in one community.",
      "page_copy": "Discover the ideal living experience at Heather Lodge, where you’ll find beautiful apartments by Carver Park in Happy Valley. Nestled in the tranquil Rock Creek neighborhood, Heather Lodge offers the perfect balance between serene park views and modern conveniences. Our community provides a wonderful opportunity to enjoy the great outdoors while being close to the vibrant lifestyle of Happy Valley.\n\nHeather Lodge boasts an array of amenities designed to suit every lifestyle. Residents can benefit from our fully equipped fitness center, relax by the seasonal swimming pool and spa, and socialize at the resident clubhouse with its inviting fireside lounge. These features create a harmonious setting perfect for unwinding or entertaining guests. Choose Heather Lodge and discover a community that blends proximity to nature with exceptional living spaces.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Carver Park in Happy Valley | Heather Lodge",
      "seo_description": "Explore Heather Lodge, offering apartments by Carver Park in Happy Valley. Enjoy great amenities and a prime park-side location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "apartments-near-clackamas-town-center-happy-valley",
      "search_query": "apartments near Clackamas Town Center TC Happy Valley",
      "category": "Transit",
      "h1_title": "Apartments Near Clackamas Town Center TC",
      "h2_subtitle": "Discover apartments near Clackamas Town Center TC at Heather Lodge, Happy Valley. Enjoy shopping convenience and a vibrant community.",
      "page_copy": "Heather Lodge offers stunning apartments near Clackamas Town Center TC in the heart of Happy Valley. Situated in the peaceful Rock Creek neighborhood, our community provides effortless access to premier shopping, dining, and entertainment venues at the bustling Clackamas Town Center. Our ideal location ensures a convenient lifestyle for those who enjoy urban benefits but relish a tranquil home setting.\n\nAt Heather Lodge, residents are treated to luxurious amenities that enhance everyday living. Whether breaking a sweat in the fully equipped fitness center, lounging by the seasonal swimming pool and spa, or socializing in the inviting resident clubhouse with its cozy fireside lounge, Heather Lodge caters to a variety of lifestyles. Embrace modern living within easy reach of Clackamas Town Center TC, all while enjoying the serenity of Happy Valley.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Clackamas Town Center in Happy Valley",
      "seo_description": "Discover Heather Lodge, offering apartments near Clackamas Town Center TC. Enjoy great amenities and a prime location in Happy Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "gresham-central-tc-max-nearby-apartments",
      "search_query": "Gresham Central TC MAX nearby apartments",
      "category": "Transit",
      "h1_title": "Gresham Central TC MAX Nearby Apartments",
      "h2_subtitle": "Discover Heather Lodge in Happy Valley, offering nearby apartments with easy access to Gresham Central TC MAX.",
      "page_copy": "Welcome to Heather Lodge, where urban convenience meets suburban tranquility with nearby apartments offering easy access to Gresham Central TC MAX. Located in Happy Valley's Rock Creek neighborhood, our community is perfect for commuters and city lovers alike who seek straightforward transit options. Enjoy seamless connectivity to downtown Gresham and Portland, while relishing the peaceful ambiance of suburban living.\n\nOur residents at Heather Lodge benefit from a robust set of amenities tailored to enhance your living experience. Stay active in our fully equipped fitness center, relax at the seasonal swimming pool and spa, or unwind in the welcoming resident clubhouse with its charming fireside lounge. Choose Heather Lodge for a harmonious blend of impeccable community features and unbeatable convenience near Gresham Central TC MAX.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gresham Central TC MAX Nearby Apartments, Heather Lodge",
      "seo_description": "Explore Heather Lodge in Happy Valley, offering nearby apartments with easy access to Gresham Central TC MAX and fantastic amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "se-holgate-blvd-max-station-apartments",
      "search_query": "SE Holgate Blvd MAX Station apartments",
      "category": "Transit",
      "h1_title": "SE Holgate Blvd MAX Station Apartments",
      "h2_subtitle": "Explore Heather Lodge in Happy Valley, offering convenient access to SE Holgate Blvd MAX Station and outstanding amenities.",
      "page_copy": "Discover Heather Lodge, the perfect choice for those seeking apartments near SE Holgate Blvd MAX Station. Our beautiful community is located in Happy Valley, nestled within the tranquil Rock Creek neighborhood. With easy access to the MAX station, residents can enjoy convenient commutes to downtown Portland and beyond, making it an ideal location for both work and play.\n\nHeather Lodge is more than just a place to live; it’s a lifestyle. Our fully equipped fitness center is perfect for staying active, while the seasonal swimming pool and spa provide a refreshing retreat. The resident clubhouse, complete with a cozy fireside lounge, offers an inviting space for social gatherings. At Heather Lodge, enjoy the perfect blend of convenience, comfort, and community near SE Holgate Blvd MAX Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "SE Holgate Blvd MAX Station Apartments | Heather Lodge",
      "seo_description": "Find your home at Heather Lodge, offering SE Holgate Blvd MAX Station apartments in Happy Valley with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "living-near-lents-town-center-se-foster-rd",
      "search_query": "living near Lents Town Center SE Foster Rd",
      "category": "Transit",
      "h1_title": "Living Near Lents Town Center SE Foster Rd",
      "h2_subtitle": "Experience living near Lents Town Center SE Foster Rd at Heather Lodge, offering a perfect blend of convenience and community.",
      "page_copy": "Welcome to Heather Lodge, where living near Lents Town Center SE Foster Rd offers you the perfect combination of urban convenience and suburban peace. Situated in Happy Valley's serene Rock Creek neighborhood, our community offers easy access to Lents Town Center SE Foster Rd, making it ideal for those who want proximity to Portland's vibrant activities without the hustle of city living.\n\nResidents of Heather Lodge enjoy access to exceptional amenities that cater to a wide range of lifestyle needs. Whether you are looking to stay fit in our fully equipped fitness center, unwind at the seasonal swimming pool and spa, or socialize with friends in the resident clubhouse featuring a cozy fireside lounge, Heather Lodge has something for everyone. Experience a welcoming community and comfortable living near Lents Town Center SE Foster Rd.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Lents Town Center SE Foster Rd at Heather Lodge",
      "seo_description": "Discover Heather Lodge, offering comfortable living near Lents Town Center SE Foster Rd with excellent amenities in Happy Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166894",
      "source": "generator",
      "page_item_url": "apartments-close-to-se-flavel-street-clackamas-county",
      "search_query": "apartments close to SE Flavel Street Clackamas County",
      "category": "Transit",
      "h1_title": "Apartments Close to SE Flavel Street",
      "h2_subtitle": "Discover Heather Lodge in Clackamas County, offering apartments close to SE Flavel Street with premium amenities.",
      "page_copy": "Heather Lodge invites you to experience the ideal mix of convenience and luxury with our apartments close to SE Flavel Street in Clackamas County. Situated in Happy Valley's beautiful Rock Creek neighborhood, our community offers residents easy access to SE Flavel Street, ensuring you are connected to important routes and the vibrant energy of the surrounding area.\n\nResidents at Heather Lodge enjoy a lifestyle rich in comfort and leisure. Our amenities include a fully equipped fitness center ready to boost your fitness regime, a seasonal swimming pool and spa perfect for relaxation, and a resident clubhouse with a cozy fireside lounge for socializing and unwinding. Experience the perfect balance of suburban tranquility and urban convenience at Heather Lodge, where apartments close to SE Flavel Street meet your every need.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to SE Flavel Street | Heather Lodge",
      "seo_description": "Live at Heather Lodge in Clackamas County, with apartments close to SE Flavel Street and excellent community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5621"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372404631"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-K8RF6FSV"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "58428986965"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "877-241-2398 "
    }
  ],
  "custom_qb_id": "5621",
  "custom_repli_id": "18372404631",
  "custom_google_gtm_id": "GTM-K8RF6FSV",
  "custom_hubspot_company_id": "58428986965",
  "custom_ppc_tracking_phone_number": "877-241-2398 "
};

export const generatedAt = '2026-10-05T21:08:16.551Z';
